

export default function ContattiHero() {
  return (
    <section className="relative bg-[#0B1F3B] pt-32 pb-20">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
          Parliamo del Tuo Brand
        </h1>
        <p className="text-xl text-white/90 mb-8 leading-relaxed">
          Richiedi la tua pre-analisi gratuita e scopri quanto vale davvero il tuo brand. Nessun impegno, solo risposte concrete.
        </p>
        <a 
          href="#contatti-form" 
          className="inline-flex items-center px-8 py-4 bg-[#22C55E] text-white font-semibold rounded-lg hover:bg-[#16A34A] transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 whitespace-nowrap"
        >
          Richiedi Pre-Analisi Gratuita
        </a>
      </div>
    </section>
  );
}
